<template>
  <div>
    <a href="#" @click.prevent="showAchievement()">
      <div class="achievements_icons_inside">
        <progress-chart v-if="achievementInfo.current"
                        :key-id="'achievement_' + _uid"
                        :percentage="achievementInfo.percentage"
                        :image="getAchievementImagePath()">
        </progress-chart>
        <div class="achievement_icon_container" v-else>
          <img :src="getAchievementImagePath()" alt="">
          <div class="achievement_locked" v-if="!achievementInfo.completed">
            <img class="" src="static/images/locked_icon.svg" alt="">
          </div>
          <div class="achievement_complete" v-else>
            <img class="" src="static/images/complete_icon.svg" alt="">
          </div>
        </div>
        <div class="achievement_info">
          <p>{{ achievementInfo.achievementLevelName }}</p>
        </div>
      </div>
    </a>
    <component :is="currentAchievement"
               :achievement-info="buildAchievementObject()"
               @close="currentAchievement = null"/>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import ProgressChart from '@/components/home/shared/ProgressChart';
import { draw } from '@/common/jQuery';
import AchievementInProgress from '@/components/home/modals/achievements/AchievementInProgress';
import AchievementLocked from '@/components/home/modals/achievements/AchievementLocked';
import NewAchievement from '@/components/home/modals/achievements/NewAchievement';

export default {
  name: 'achievement',
  components: {
    ProgressChart,
  },
  props: {
    achievementInfo: Object,
    categoryName: String,
    achievementIndex: Number,
  },
  data() {
    return {
      currentAchievement: null,
    };
  },
  computed: {
    ...mapState('profile', [
      'achievementNotificationData',
    ]),
  },
  created() {
    this.$nextTick(() => {
      const { percentage, current } = this.achievementInfo;
      // eslint-disable-next-line
      if (percentage && current) draw(`achievement_${this._uid}`, percentage);
    });
  },
  methods: {
    ...mapMutations('profile', [
      'setNotificationRewardId',
      'setNotificationRewardName',
      'setNotificationPrizeWon',
      'setCheckedNotificationId',
      'setCheckedNotificationReadStatus',
    ]),
    buildAchievementObject() {
      return { ...this.achievementInfo, image: this.getAchievementImagePath(), categoryName: this.categoryName.toUpperCase() };
    },
    getAchievementImagePath() {
      return `static/images/achievements_cat/${this.categoryName}_${this.achievementIndex}.png`;
    },
    showAchievement() {
      const { current, completed } = this.achievementInfo;
      if (completed) {
        const { awardedCorrelationId, awardedPrizeDesc, achievementLevelName } = this.achievementInfo;

        this.setNotificationRewardName({ value: awardedPrizeDesc });
        this.setNotificationPrizeWon({ value: !!awardedCorrelationId });

        const categoryName = this.categoryName.toUpperCase();
        const { id, gameId, readStatus } = (this.achievementNotificationData || []).filter(notification => notification.text === `${categoryName}_${achievementLevelName}`)[0];

        this.setNotificationRewardId({ value: gameId });
        this.setCheckedNotificationId({ value: id });
        this.setCheckedNotificationReadStatus({ value: readStatus });
      }
      // eslint-disable-next-line
      this.currentAchievement = completed ? NewAchievement : current ? AchievementInProgress : AchievementLocked;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/achievements/Achievement.vue